import { DropzoneOptions, FileRejection } from 'react-dropzone';
import { FILE_TYPES } from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';
import {
  AGREEMENT_ERROR_CODES,
  AGREEMENT_LIMITS,
  AgreementField,
} from 'models/Agreement';
import { getHasEmptyCustomLabel, getHasSignatureField } from 'agreementUtils';
import { ObjectValues } from 'types';

export const AGREEMENT_PDF_DROPZONE_OPTIONS: DropzoneOptions = {
  accept: FILE_TYPES.PDF,
  multiple: false,
};

export const AGREEMENT_FILE_ERROR_KEYS: Record<string, string> = {
  [AGREEMENT_ERROR_CODES.FILE_INVALID]: 'agreementFileInvalid',
  [AGREEMENT_ERROR_CODES.FILE_TOO_LARGE]: 'agreementFileTooLarge',
  [AGREEMENT_ERROR_CODES.FILE_ENCRYPTED]: 'agreementFileEncrypted',
  [AGREEMENT_ERROR_CODES.FILE_PAGE_COUNT_INVALID]:
    'agreementFilePageCountInvalid',
};

export const AGREEMENT_FILE_LIMIT_PARAMS = {
  size: AGREEMENT_LIMITS.MAX_FILE_SIZE_MB,
  max: AGREEMENT_LIMITS.MAX_PAGES,
};

export const getIsAgreementFileError = (code: string) =>
  !!AGREEMENT_FILE_ERROR_KEYS[code];

export const getDroppedFile = (accepted: File[], rejections: FileRejection[]) =>
  accepted[0] || rejections[0]?.file;

export const getIsAgreementPageCountValid = (pageCount: number) =>
  pageCount <= AGREEMENT_LIMITS.MAX_PAGES;

export const getCanActivateAgreement = (
  file: File | undefined,
  fields: AgreementField[],
) => !!file && getHasSignatureField(fields) && !getHasEmptyCustomLabel(fields);

export const AGREEMENT_SETUP_EXITS = {
  ACTIVATED: 'activated',
  CLOSED: 'closed',
  DOCUSIGN_CONNECTED: 'docusign-connected',
} as const;

export type AgreementSetupExit = ObjectValues<typeof AGREEMENT_SETUP_EXITS>;
